import Tooltip, { TooltipPlacement } from "../tooltips/Tooltip";
import { TextWithInlineTokens } from "../text/TextWithInlineTokens";

export type TooltipTokenContent = {
    label: string;
    tooltipHeader: string;
    tooltipHtmlBody: string;
};

type TooltipTokenProps = {
    text?: string;
    /** Must contain exactly one capture group; its value is passed to `buildToken`. */
    tokenRegex: RegExp;
    buildToken: (capturedValue: string) => TooltipTokenContent;
    className?: string;
    enabled?: boolean;
    placement?: TooltipPlacement;
};

/**
 * Renders `text`, replacing every regex match with a clickable badge that opens a tooltip
 * with the header and HTML body returned by `buildToken`.
 */
export function TooltipToken({
    text,
    tokenRegex,
    buildToken,
    className,
    enabled = true,
    placement = TooltipPlacement.Top,
}: TooltipTokenProps) {
    return (
        <TextWithInlineTokens
            text={text}
            tokenRegex={tokenRegex}
            className={className}
            enabled={enabled}
            renderToken={(capturedValue, key) => {
                const { label, tooltipHeader, tooltipHtmlBody } = buildToken(capturedValue);
                return (
                    <Tooltip
                        key={key}
                        header={tooltipHeader}
                        title={tooltipHtmlBody}
                        placement={placement}
                        className="d-inline-block"
                        tipClassName="tooltip-token-box"
                    >
                        <span
                            role="button"
                            tabIndex={0}
                            className="color-primary badge badge-pill badge-default padding-xs inherit-pills cursor-pointer"
                        >
                            {label}
                        </span>
                    </Tooltip>
                );
            }}
        />
    );
}
